import axios from "axios";

export async function registrarSolicitud(datos){
    try{
        const response = await axios.post(URL_REGISTRO_SOLICITUD, datos).catch(error => {
            throw new Error(error.response.data);
        });

        return true;
    }catch(error){
        console.log(error);
        return false;
    }
}
export async function obtenerDatosSolicitud(datos, funcionRecepcion){
    try{
        const response = await axios.post(URL_DATOS_SOLICITUD, datos).catch(error => {
            throw new Error(error.response.data);
        });

        funcionRecepcion(response.data);
    }catch(error){
        console.log(error);
        return false;
    }
}


// CONSTANTES
const URL_REGISTRO_SOLICITUD = process.env.REACT_APP_URL_REGISTRO_SOLICITUD;
const URL_DATOS_SOLICITUD = process.env.REACT_APP_URL_DATOS_SOLICITUD;